import React from 'react';

export const ChevronRightIcon = ({ color = '#344054',  }: { color?: string }) => {
    return (
        <svg
            width='8'
            height='12'
            viewBox='0 0 8 12'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1.5 11L6.5 6L1.5 1'
                stroke='#667085'
                strokeWidth='1.67'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
